import script from "./account-info.vue?vue&type=script&lang=ts&setup=true"
export * from "./account-info.vue?vue&type=script&lang=ts&setup=true"

import "./account-info.vue?vue&type=style&index=0&id=6c8b0715&lang=scss"

const __exports__ = script;

export default __exports__